import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../../Components/Button"

import styles from "./dangerZone.module.less"

const { Text } = Typography

// Deactivate Recover. The plumbing existed but had no UI control, so the feature could
// be turned on but never off.
const DangerZone = ({ fetching, isActivated, onDeactivate }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.danger}>
      <Flex align="center" justify="space-between" gap={16} wrap="wrap">
        <Flex vertical gap={4} style={{ minWidth: 0 }}>
          <Text strong>{t("Deactivate Recover")}</Text>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {t(
              "Stop syncing new chargebacks and pause fighting new disputes. Your profile and past evidence are kept."
            )}
          </Text>
        </Flex>
        <Button
          danger
          disabled={fetching || !isActivated}
          onClick={onDeactivate}
          text={t("Deactivate Recover")}
        />
      </Flex>
    </div>
  )
}

export default DangerZone
